/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

const buildGetURL = (url, params) => {
	const getURL = new URL(url);
	getURL.search = new URLSearchParams(params);

	return getURL;
};

export default buildGetURL;
